import React, { Fragment } from "react";
import classnames from "classnames";

import Context from "shared/util/Context";
import Str from "shared/components/Str";
import Strf from "shared/components/Strf";

const Top = () => {
	const isIndia = Context.has("INDIAN_SPLASH_PAGES");

	return (
		<div
			className={classnames("splashdtf-top", {
				"splashdtf-top--isIndia": isIndia,
			})}
		>
			<div className="splashdtf-centered">
				<div className="splashdtf-top-text">
					{isIndia &&
						<Fragment>
							<h1 className="splashdtf-top-text-heading splashdtf-top-text-heading--isIndia">
								<Str>Find my kind</Str>
							</h1>
							<div className="splashdtf-top-text-manifesto splashdtf-top-text-manifesto--isIndia">
								<Strf vars={{ br: <br /> }}>
									OkCupid is the only dating app that connects $br
									people based on interests, beliefs and quirks. $br
									Form meaningful connections and find $br
									great dates on OkCupid today.
								</Strf>
							</div>
						</Fragment>
					}
					{!isIndia &&
						<Fragment>
							<h1 className="splashdtf-top-text-heading">
								<Str>Dating Deserves Better</Str>
							</h1>
							<div className="splashdtf-top-text-manifesto">
								<Str>
									On OkCupid, you’re more than just a photo. You have stories to tell, and
									passions to share, and things to talk about that are more interesting than
									the weather. Get noticed for who you are, not what you look like.
									Because you deserve what dating deserves: better.
								</Str>
							</div>
						</Fragment>
					}
				</div>
			</div>
		</div>

	);
};

export default Top;



// WEBPACK FOOTER //
// ./src/apps/splash_desktop/components/Top.jsx